export default __webpack_public_path__ + "static/portfolio_gallery_6-d33bcb92b7897957699042e61f0b48cc.jpg";